import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Accordion, Table, Loader, Icon} from 'semantic-ui-react';
import moment from 'moment';
import _ from 'lodash';
import {Actions} from '../../../../../common/actions';
import {dateFormatReservation} from '../../../../../common/constants/datesFormat';
import User from '../popup/user';

class BackOrders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'activeIndex': 0,
    };
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    const {code} = this.props;
    this.props.fetchBackOrdersDetail(code);
  }

  componentDidUpdate(prevProps) {
    const {code} = this.props;
    if (code !== prevProps.code) {
      this.props.fetchBackOrdersDetail(code);
    }
  }

  handleClick = (e, titleProps) => {
    const {activeIndex} = this.state;
    const {index} = titleProps;
    const newIndex = activeIndex === index ? -1 : index;
    this.setState({'activeIndex': newIndex});
  };

  renderItems() {
    const {backOrdersData} = this.props;

    if (!backOrdersData.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={6}>
            No hay datos disponibles
          </Table.Cell>
        </Table.Row>
      );
    }
    return backOrdersData.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.dealer}</Table.Cell>
          <Table.Cell textAlign='center'>{element.agency}</Table.Cell>
          <Table.Cell textAlign='right'>{element.quantity}</Table.Cell>
          <Table.Cell textAlign='center'>{element.orderCode}</Table.Cell>
          <Table.Cell textAlign='center'>
            {element.date ?
              moment(element.date).format(dateFormatReservation) :
              ''}
          </Table.Cell>
          <Table.Cell textAlign='center'>
            <User username={element.username} />
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  renderData() {
    const {loading} = this.props;
    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderItems();
  }

  render() {
    const {activeIndex} = this.state;
    const {backOrdersData} = this.props;

    return (
      <Accordion fluid>
        <Accordion.Title
          active={activeIndex === 0}
          index={0}
          onClick={this.handleClick}
        >
          <Table striped className='toyota-grid'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign='left' colSpan={5}>
                  Back Orders
                  <span className='quantity-container'>
                    {_.sumBy(backOrdersData, 'quantity')}
                  </span>
                </Table.HeaderCell>
                <Table.HeaderCell colSpan={1} textAlign='right'>
                  <Icon name='dropdown' />
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
          </Table>
        </Accordion.Title>

        <Accordion.Content active={activeIndex === 0}>
          <Table striped className='toyota-grid'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign='center'>
                  Concesionario
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Agencia</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Cantidad</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Pedido</Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>
                  Fecha de Pedido
                </Table.HeaderCell>
                <Table.HeaderCell textAlign='center'>Usuario</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>{this.renderData()}</Table.Body>
          </Table>
        </Accordion.Content>
      </Accordion>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'loading': state.partModals.loadingBackOrdersDetail,
    'backOrdersData': state.partModals.backOrdersDetail,
  };
};

const {fetchBackOrdersDetail} = Actions;

export default connect(mapStateToProps, {
  fetchBackOrdersDetail,
})(BackOrders);
